(function (angular) {
    angular.module('bizPartEngage').service('core.completeregisterService', completeRegisterService);

    completeRegisterService.$inject = ["$http"];

    function completeRegisterService($http) {
        this.GetUserByActionGuid = function (guid) {
            return $http.get(siteRootPath + 'api/user/GetUserByActionGuid', { params: { guid } });
        };

        this.GetGuidInfo = function (guid) {
            return $http.get(siteRootPath + 'api/user/GetGuidInfo', { params: { guid } });
        }

        this.CompleteRegistration = function (guid, user, password, extCustomFields, code) {
            return $http.post(siteRootPath + 'api/user/CompleteRegistration', { Guid: guid, User: user, Password: password || '', ExtCustomFields: extCustomFields, Code: code || '' });
        };

        this.SendVerificationCode = function (guid, email) {
            return $http.post(siteRootPath + 'api/user/SendVerificationForCreateUserForUnit', { Guid: guid, Email: email });
        };
    }
})(window.angular);